export default __webpack_public_path__ + "static/media/world map.474f2bc6.png";